<template>
	<div class="base-loader" :class="mode">
		<svg version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="50px" height="50px" viewBox="0 0 50 50" style="enable-background: new 0 0 50 50" xml:space="preserve">
			<path fill="#cccccc" d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z">
				<animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.6s" repeatCount="indefinite"></animateTransform>
			</path>
		</svg>
	</div>
</template>

<script setup>
	const props = defineProps({
		mode: {
			type: String,
			default: 'inline',
		},
	});
</script>

<style scoped>
	.inline {
		text-align: center;
	}
	.inline svg {
		width: 40px;
		height: 40px;
	}
	.fullpage {
		position: fixed;
		z-index: 999999;
		background: #fff;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		height: 100vh;
		width: 100%;
	}
</style>
